import i18n from '../../i18n.js'
import React from 'react'
import { Link } from 'react-router-dom'
import PriceCard from './payment.priceCard.js'
import stripe from '../../assets/icons/stripe_144x96.svg'

export default function PaymentPrices() {
    const plan = i18n.t('payment.plan')
    const month = i18n.t('payment.month')
    const months = i18n.t('payment.months')
    const title = i18n.t('payment.card-title')
    const price = i18n.t('payment.price')

    return (
        <div className={'container'}>
            <div className="prices shadow mb-2 p-2">
                <div className="table-responsive">
                    <table className="table table-bordered border-dark text-center align-middle">
                        <thead className="">
                            <tr className="border border-bottom border-white rowTitleRadius">
                                <th
                                    rowSpan={2}
                                    className="border border-0"
                                ></th>
                                <th
                                    scope="col"
                                    colSpan='6'
                                    className="border border-0 headerTitle"
                                    id='headerSellerTitle'
                                >
                                    {i18n.t('payment.tableSeller.row1')}
                                </th>
                            </tr>
                            <tr className="border border-0 text-white">
                                <td
                                    className="headerSubtitle"
                                    colSpan='2'
                                >
                                    {i18n.t('payment.tableSeller.row2.col2')}
                                </td>
                                <td
                                    className="headerSubtitle"
                                    colSpan='2'
                                >
                                    {i18n.t('payment.tableSeller.row2.col3')}
                                </td>
                                <td
                                    className="headerSubtitle"
                                    colSpan='2'
                                >
                                    {i18n.t('payment.tableSeller.row2.col4')}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col2.subcol1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col2.subcol2',
                                                )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col3.subcol1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col3.subcol2',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col4.subcol1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row3.col4.subcol2',
                                        )}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row4.col1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row4.col2.subcol1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row4.col2.subcol2',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row4.col3.subcol1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row4.col3.subcol2',
                                        )}
                                    </b>
                                </td>
                                <td colSpan='2'>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row4.col4',
                                        )}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row5.col1',
                                        )}
                                    </b>
                                </td>
                                <td colSpan='2'>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row5.col2',
                                        )}
                                    </b>
                                </td>
                                <td colSpan='2'>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row5.col3',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row5.col4.subcol1',
                                        )}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row5.col4.subcol2',
                                        )}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row6.col1',
                                        )}
                                    </b>
                                </td>
                                <td colSpan='2'>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row6.col2',
                                        )}
                                    </b>
                                </td>
                                <td colSpan='2'>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row6.col3',
                                        )}
                                    </b>
                                </td>
                                <td colSpan='2'>
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row6.col4',
                                        )}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="7" className="services">
                                    <b>
                                        {i18n.t(
                                            'payment.tableSeller.row7'
                                        )}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row8.col1')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row9.col1')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row10.col1')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row11.col1')}
                                </td>
                                <td colSpan='2'>
                                    {i18n.t('payment.tableSeller.row11.col2')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row12.col1')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row13.col1')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row14.col1')}
                                </td>
                                <td colSpan='2'>
                                    {i18n.t('payment.tableSeller.row14.col2')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableSeller.row15.col1')}
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td colSpan='2'>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="text-start tablesAclaration">
                        <b>{i18n.t('payment.tablesAclaration1')}</b><br/>
                        <b>{i18n.t('payment.tablesAclaration2')}</b>
                    </p>

                </div>
                <div className="table-responsive mt-4">
                    <table className="table table-bordered border-dark text-center align-middle">
                        <thead className="">
                            <tr className="border border-bottom border-white rowTitleRadius">
                                <th
                                    rowSpan={2}
                                    className="border border-0"
                                ></th>
                                <th
                                    scope="col"
                                    colspan="3"
                                    className="border border-0 headerTitle"
                                    id='headerBuyerTitle'
                                >
                                    {i18n.t('payment.tableBuyer.row1')}
                                </th>
                            </tr>
                            <tr className="border border-0 text-white">
                                <th
                                    scope="col"
                                    className="border border-start-0 headerSubtitle"
                                >
                                    {i18n.t('payment.tableBuyer.row2.col2')}
                                </th>
                                <th
                                    scope="col"
                                    className="border border-start-0 col-3 align-middle headerSubtitle"
                                >
                                    {i18n.t('payment.tableBuyer.row2.col3')}
                                </th>
                                <th
                                    scope="col"
                                    className="border border-start-0 headerSubtitle"
                                >
                                    {i18n.t('payment.tableBuyer.row2.col4')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>
                                    <b>
                                        {i18n.t('payment.tableBuyer.row3.col1')}
                                    </b>
                                </th>
                                <td>
                                    <b>
                                        {i18n.t('payment.tableBuyer.row3.col2')}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t('payment.tableBuyer.row3.col3')}
                                    </b>
                                </td>
                                <td>
                                    <b>
                                        {i18n.t('payment.tableBuyer.row3.col4')}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" className="services">
                                    <b>{i18n.t('payment.tableBuyer.row4')}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row5.col1')}
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            {/*<tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row6.col1')}
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td>
                                    {i18n.t('payment.tableBuyer.row6.col4')}
                                </td>
                            </tr>*/}
                            <tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row7.col1')}
                                </td>
                                <td>
                                    {i18n.t('payment.tableBuyer.row7.col2')}
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row8.col1')}
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row9.col1')}
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    {i18n.t('payment.tableBuyer.row9.col4')}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row10.col1')}
                                </td>
                                <td>
                                    {i18n.t('payment.tableBuyer.row10.col2')}
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {i18n.t('payment.tableBuyer.row11.col1')}
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                                <td>
                                    <i className="bi bi-x-lg icon-cross"></i>
                                </td>
                                <td>
                                    <i className="bi bi-check-lg icon-check"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="text-start tablesAclaration">
                        <b>{i18n.t('payment.tablesAclaration1')}</b>
                    </p>
                </div>
                <div>
                    <a
                        href={
                            'https://buy.stripe.com/bJebJ0fr208Z1h61mh57W08'
                        }
                        target={'_blank'}
                        className="fix-button-link btn btn-outline-primary g-action-button rounded-pill"
                    >
                        <span>PAGAR</span>
                        <img src={stripe} alt="Stripe logo" style={{height: '30px', backgroundColor: '#6C76E6', borderRadius: '5px'}} />
                    </a>
                </div>
            </div>
        </div>
    )
}
